import React, {useEffect, useState} from 'react';
import {FiUploadCloud} from 'react-icons/fi';
import {useDocumentContext} from '../../SimpleDocument';
import {uploadFile} from '../../api/Document.api';
import uuid from 'react-uuid';
import {refreshAccessToken} from "../../api/Auth.api";
import {FileFields} from "../../utils/FieldUtils";
import {documentCategory} from "../../utils/Common";
import {getFileExtension, isAllowedUpload, sleep} from "../../utils/ExtensionUtils";
import {checkName, checkSize} from "../../utils/ValidatorUtils";
import {useTranslation} from "react-i18next";
import {message, theme} from "antd";

const Index = (props) => {

    const {
        listProgressFiles,
        dataSource,
        setListProgressFiles,
        externalReferenceCode,
        moduleId,
        appId,
        setReloadData,
        isSingle
    } = useDocumentContext();

    const [disabled, setDisabled] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setDisabled((dataSource?.length > 0 || Object.keys(listProgressFiles)?.length > 0 || loading) && isSingle);
    }, [dataSource, isSingle, listProgressFiles, loading]);

    const [isActiveDrag, setActiveDrag] = useState(false)

    const {useToken} = theme;
    const {token} = useToken();

    const {t} = useTranslation()

    const primaryTextColor = {
        color: "var(--primary-color)"
    };

    const secondBgColor = {
        backgroundColor: token.colorPrimaryBg
    };

    async function uploadMultipleFiles(fileList) {

        if (disabled && dataSource?.length > 0) {
            message.error(t("tnp.components.file.uploadMaxFile"))
            return
        }

        setLoading(true)

        await refreshAccessToken().then(r => {
        })

        const length = fileList?.length;

        for (let i = 0; i < length; i++) {

            await upload(fileList[i]);
        }

        resetDataInput()

        setLoading(false)
    }

    async function upload(file) {

        if (!checkName(file.name)) return

        else if(file && !((file?.name?.includes(".xls") || file?.type?.includes(".sheet")) )){
            message.error(t("tnp.components.file.updateErrorType"))
            return
        }
        const uid = uuid();

        const controller = new AbortController();

        const initProgressFile = mapFileItem({
            uid,
            name: file.name,
            file: file,
            controller: controller
        }, 0);

        const ext = getFileExtension(file.name)

        if (!isAllowedUpload(ext)) {
            initProgressFile.error = {
                message: t("tnp.components.file.updateErrorType"),
                type: "client"
            }
        } else if (!checkSize(file.size)) {
            initProgressFile.error = {
                message:  t("tnp.components.file.updateMaxSize"),
                type: "client"
            }
        }

        setListProgressFiles((state) => {

            const cloneState = {
                [uid]: initProgressFile,
                ...state
            };

            return {...cloneState};
        });

        if (!!initProgressFile.error) return

        const formData = new FormData();

        formData.append(FileFields.metadata, JSON.stringify({appId, moduleId}));
        formData.append(FileFields.pkCode,props?.referenceCodeItem || externalReferenceCode);
        formData.append(FileFields.parentId, '0');
        formData.append(FileFields.category, documentCategory.attached);
        formData.append(FileFields.file, file);

        const onUploadProgress = (progressEvent) => {

            const total = progressEvent?.total || 0;
            const loaded = progressEvent?.loaded;

            let percent = (loaded / total) * 100;

            percent = percent === 100 ? 99 : parseInt(String(percent));

            setListProgressFiles((state) => {

                const cloneState = {...state};

                cloneState[uid] = mapFileItem(initProgressFile, percent);

                return {...cloneState};
            });
        };

        await uploadFile(formData, onUploadProgress, {signal: controller.signal}).then(r => {

            setListProgressFiles((state) => {

                const cloneState = {...state};

                cloneState[uid] = mapFileItem(initProgressFile, 100);

                return {...cloneState};
            });

            sleep(500).then(() => {
                setReloadData(true)
            })


        }).catch(e => {

        });
    }

    function resetDataInput() {

        const node = document.getElementById("upload-drag-file")

        node.value = ""
    }

    const mapFileItem = (item, percent) => {

        return {
            extension: item?.name?.split('.').pop(),
            ...item,
            percent: Number(percent)
        };
    };

    const triggerBrowserFile = () => {

        if (disabled) {
            message.error(t("tnp.components.file.uploadMaxFile"))
            return
        }

        const uploadFile = document.getElementById(`upload-drag-file`);

        uploadFile?.click();
    };

    async function onDrop(e) {
        e.preventDefault()

        if (isSingle && e.dataTransfer.files?.length > 1) {

            message.error(t("tnp.components.file.uploadMaxFile"))
            return
        }
        await uploadMultipleFiles(e.dataTransfer.files).then(() => {

        })
    }

    return (
        <div
            id={"simple-document-content"}
            className={`simple-document-content`}
            onClick={triggerBrowserFile}
            style={{
                border: isActiveDrag ? `1px dashed var(--primary-color)` : "1px solid #EAECF0",
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.6 : 1
            }}
            onMouseEnter={() => {
                setActiveDrag(true)
            }}
            onMouseLeave={() => {
                setActiveDrag(false)
            }}
            onDrop={(e) => {
                onDrop(e).then(r => {
                })

                setActiveDrag(false)
            }}
            draggable={true}
            onDragLeave={(e) => {
                setActiveDrag(false)
            }}
            onDragOver={(e) => {
                e.preventDefault();

                setActiveDrag(true)
            }}
            onDragExit={(e) => {
                e.preventDefault()
            }}
            onDragEnter={(e) => {
                e.preventDefault()
            }}
        >

            <input
                type='file'
                id={'upload-drag-file'}

                multiple={!isSingle}
                style={{display: 'none'}}
                accept={props?.accept}
                onChange={(e) => uploadMultipleFiles(e.target.files)}
            />

            <div className={'upload-icon-wrapper'} style={secondBgColor}>
                <FiUploadCloud className={'upload-icon'} style={primaryTextColor}/>
            </div>
            <div className={'upload-content-wrapper'}>
                <p className={'upload-title'}><span style={primaryTextColor}>{t("DGDocument.text.onclick")}</span>
                    {t("DGDocument.description.drag.title")}
                </p>
                <p className={'upload-description'}>{t("DGDocument.description.drag.hint")}</p>
            </div>
        </div>
    );
};

export default Index;